import React, { useContext } from "react";
import CountUp from "react-countup";
import { ProfileContext } from "../../context/ContextProfile";

// Region label per village. Hardcoded for now — ideally this comes from the API.
const HUESCA = [
  "Alcubierre",
  "Bárcabo",
  "Bierge",
  "Boltaña",
  "Casbas de Huesca",
  "Graus",
  "Robres",
];
function regionFor(name) {
  if (HUESCA.includes(name)) return "Huesca - Aragón";
  if (name === "Fabero") return "León";
  return "Galicia";
}

function Header() {
  const { village } = useContext(ProfileContext);

  if (!village.villageData) return null;

  const { displayName, coordinates, profilePicture } = village.villageData;
  const gallery = village.villagePictures?.mainGallery || [];
  const photoCount = gallery.length;
  const featuredCount = village.villageMostVisited?.length || 0;

  const avatarUrl = `https://aldealista.com/p/${profilePicture}`;
  // Cover = the village's first real photo (skip videos), falling back to the
  // avatar image, shown blurred behind the header.
  const firstPhoto = gallery.find((g) => g.isVideo != 1);
  const coverUrl = `https://aldealista.com/p/${
    firstPhoto?.path?.[0] || profilePicture
  }`;

  // The village profile URL (e.g. https://aldealista.com/graus) — never a subpath.
  const shareUrl =
    typeof window !== "undefined"
      ? `${window.location.origin}/${village.code}`
      : "";

  const onShare = async () => {
    const data = {
      title: `${displayName} · Aldealista`,
      text: `Descubre ${displayName} en Aldealista`,
      url: shareUrl,
    };
    try {
      if (navigator.share) {
        await navigator.share(data);
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(shareUrl);
      }
    } catch (e) {
      /* user cancelled or unsupported — ignore */
    }
  };

  return (
    <div className="profile-header">
      <div className="profile-cover">
        <img
          src={coverUrl}
          alt=""
          className="profile-cover-img"
          aria-hidden="true"
          onError={(e) => {
            if (e.currentTarget.src !== avatarUrl) e.currentTarget.src = avatarUrl;
          }}
        />
      </div>

      <div className="image_outer_container profile-avatar">
        <div className="image_inner_container">
          <img src={avatarUrl} alt={displayName} />
        </div>
      </div>

      <div className="profile-meta">
        <p className="title-qr">{displayName}</p>
        <p className="region">{regionFor(displayName)}</p>
        <p className="coordinates">{coordinates}</p>

        <div className="profile-stats">
          <div className="profile-stat">
            <b>
              <CountUp end={photoCount} duration={1.4} />
            </b>
            <span>Fotos</span>
          </div>
          <div className="profile-stat">
            <b>
              <CountUp end={featuredCount} duration={1.4} />
            </b>
            <span>Destacados</span>
          </div>
        </div>

        <div className="profile-actions">
          <a className="profile-cta" href="https://aldealista.com">
            <i className="fa fa-download" aria-hidden="true"></i>
            Descargar la app
          </a>
          <button
            type="button"
            className="profile-share"
            onClick={onShare}
            aria-label="Compartir perfil"
            title="Compartir"
          >
            <i className="fa fa-share-alt" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Header;
